import { useAuth0 } from "@auth0/auth0-react";

import type { FC } from "react";

const LogoutPage: FC = () => {
  const { logout } = useAuth0();
  void logout({
    logoutParams: { returnTo: `${globalThis.location.protocol}//${globalThis.location.host}/` },
  }).catch(console.error);
  return <></>;
};

export default LogoutPage;
